<template>
    <div id="LqsAnalyserList">
        <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="container-fluid mt-2">
            <div class="row space-between pr-3 mb-1">
                <div></div>

            </div>
            <div class="row" v-if="viewASINsDetailedData.length">
                <div class="col-12">
                    <div class="card d-flex justify-content-between flex-row mt-3">
                        <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
                            Listing Quality Score (LQS) Analysis
                        </div>
                        <router-link to="/lqs-analyser-global" style="text-decoration: none">
                            <button style="padding: 5px 20px" class="btn navigationButton"
                                type="button">
                                <i class="fa fa-arrow-left mr-2"></i>
                                <span style="font-size: 13px">Back</span>
                            </button>
                        </router-link>
                    </div>

                </div>
                <div class="col-12">
                    <div class="card pt-2" v-for="(data, i) of viewASINsDetailedData" :key="'lqsgraph' + i">
                        <lqs-card :viewLqsListingdata="data.lqs_analysis" :viewLqsGraph="data.total"
                            :timestamp="data.timestamp" :asinData="data.asin" />
                    </div>
                </div>
            </div>
            <div v-else class="noData">No Data !</div>
        </div>
    </div>
</template>

<script>
import LqsCard from "./LqsCard.vue";

export default {
    name: "ReqASINsDetailed",
    components: { LqsCard },

    data: function () {
        return {
            viewASINsDetailedData: [],
            loader: false,
        };
    },

    mounted() {
        this.getASINsDetails();
    },
    methods: {
        getASINsDetails() {
            let self = this;
            self.loader = true;
            let payload = {
                request_id: this.$route.params.reqId,
                start: this.$route.params.startDate,
                end: this.$route.params.endDate,
            };
            const url = "/api/global_demo/viewasinlist";
            self.$http
                .post(url, payload)
                .then((response) => {
                    if (Object.keys(response.data).length)
                        self.viewASINsDetailedData = response.data.data;
                    self.loader = false;
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },
    },
};
</script>

<style scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}

.flex-start {
    display: flex;
    justify-content: start;
}

.mainHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1.3125rem;
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.textColor {
    color: #818890 !important;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

.inputBox {
    height: 30px;
    border: 1px solid silver;
    display: flex;
    justify-content: start;
    background: white;
}

.inputBox input {
    border-radius: 0px;
    border: none !important;
}

.sideBorder {
    border-right: 1px solid #c1c1c1;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}

.cardButton {
    margin-left: 10px;
}

.productCart {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.productImg {
    width: 200px;
}

.product-title {
    font-size: 18px;
}

.productImg img {
    width: 100%;
}

.graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
}

.asinBadge {
    /* background: '#9683b3'; */
    background: "#9683b3";
}

.cross-icon {
    color: black;
    background: white;
}

.crossIcon {
    cursor: pointer;
    font-size: 8px;
}

.space-between {
    display: flex;
    justify-content: space-between;
}

thead {
    background: none;
    font-family: sans-serif;
    background: #9683b3;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
}

tbody {
    font-family: sans-serif;
    font-size: 13px;
}

.pinkColor {
    background: rgb(255 185 185);
    font-weight: bold;
}

.skyColor {
    background: rgb(199 224 255);
    font-weight: bold;
}

.no-data {
    font-size: 16px;
    text-align: center;
    padding: 10px;
    color: red;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.noData {
    border: 1px solid #fbb1b1;
    border-radius: 5px;
    padding: 10px;
    background: #fff7f7;
}
</style>
